import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/SweepsMerchantLogos/GET';

export const SWEEPS_MERCHANT_LOGOS_GET_SUCCESS = `${rootActionPath}_${SUCCESS_SUFFIX}`;
export const SWEEPS_MERCHANT_LOGOS_GET_FAILURE = `${rootActionPath}_${FAILURE_SUFFIX}`;
